(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/sportinfo/assets/javascripts/sportinfo.js') >= 0) return;  svs.modules.push('/components/sportinfo/sportinfo/assets/javascripts/sportinfo.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  Switch = _ReactRouterDOM.Switch,
  Route = _ReactRouterDOM.Route,
  useLocation = _ReactRouterDOM.useLocation,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$components$sport = svs.components.sportinfo.common.constants,
  getSelectedOnPaths = _svs$components$sport.getSelectedOnPaths,
  regexSportinfoPathnames = _svs$components$sport.regexSportinfoPathnames;
const ItemsMenu = svs.ui.ReactItemsMenu.ItemsMenu;
const LinkItemRoute = svs.components.lbUtils.linkItemRoute.LinkItemRoute;
const getDefaultRoute = svs.components.sportinfo.configs.ContentConfig.getDefaultRoute;
const SportinfoContentView = svs.components.sportinfo.sportinfoContentView.SportinfoContentView;
const useExternalMatchIds = svs.components.sport.statisticsCommon.useExternalMatchIds;
const Sportinfo = _ref => {
  let _ref$basePath = _ref.basePath,
    basePath = _ref$basePath === void 0 ? '/' : _ref$basePath,
    matchId = _ref.matchId,
    branding = _ref.branding,
    className = _ref.className,
    eventNumber = _ref.eventNumber,
    productId = _ref.productId,
    FallbackComp = _ref.FallbackComp,
    _ref$activeTabBasePat = _ref.activeTabBasePaths,
    activeTabBasePaths = _ref$activeTabBasePat === void 0 ? [] : _ref$activeTabBasePat,
    appendTabSearchParams = _ref.appendTabSearchParams,
    tabComponent = _ref.tabComponent,
    tabAreaClassName = _ref.tabAreaClassName,
    drawNumber = _ref.drawNumber,
    setActiveTab = _ref.setActiveTab,
    setCoupon = _ref.setCoupon,
    isWideDevice = _ref.isWideDevice,
    matchState = _ref.matchState,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    content = _ref.content,
    theme = _ref.theme,
    sportType = _ref.sportType,
    _ref$menuOptions = _ref.menuOptions,
    menuOptions = _ref$menuOptions === void 0 ? {
      hiddenScrollbar: true,
      useScrollFaders: false,
      useScrollHelpers: false
    } : _ref$menuOptions,
    _ref$eventTypeId = _ref.eventTypeId,
    eventTypeId = _ref$eventTypeId === void 0 ? 1 : _ref$eventTypeId,
    lazyComponentsMap = _ref.lazyComponentsMap;
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const isSportinfoPathname = Boolean(location.pathname.match(regexSportinfoPathnames));

    const menuItemsPathnames = menuItems.map(item => item.to.pathname).filter(item => item !== '');
    const regexMenuItems = new RegExp("(".concat(menuItemsPathnames.join('|'), ")$"));
    const isMenuItemAvailable = Boolean(location.pathname.match(regexMenuItems));
    if (menuItems.length > 0 && isSportinfoPathname && !isMenuItemAvailable) {
      const pathname = location.pathname.replace(regexSportinfoPathnames, '');
      history.replace({
        pathname,
        search: location.search
      });
    }
  }, [menuItems]);
  const isModalOpen = document.querySelector('.lb-modal-is-open');
  const renderItemsMenu = (isModalOpen || isWideDevice) && menuItems.length > 0;
  const mutualsElementClassName = 'mutuals';
  const _useExternalMatchIds = useExternalMatchIds(matchId, productId),
    externalId = _useExternalMatchIds.externalId;
  const activeMenuItem = document.querySelector('.items-menu-active');
  useEffect(() => {
    if (activeMenuItem) {
      activeMenuItem.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, [activeMenuItem]);
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    oldDefaultRoute = _useState2[0],
    setOldDefaultRoute = _useState2[1];
  useEffect(() => {
    if (sportType && matchState) {
      const defaultRoute = getDefaultRoute({
        sportType,
        matchState,
        providerIds: externalId,
        productId
      });
      if (oldDefaultRoute !== defaultRoute) {
        if (defaultRoute) {
          const url = {
            pathname: "".concat(basePath).concat(defaultRoute),
            search: location.search
          };
          url.pathname = url.pathname.replace(/\/\/+/, '/');
          history.replace(url);
        }
        setOldDefaultRoute(defaultRoute);
      }
    }
  }, [sportType, matchState, externalId, productId]);
  const itemsMenuClassNames = ['side-nav-statistics-menu'];
  if (branding) {
    itemsMenuClassNames.push(branding);
  }
  return React.createElement(React.Fragment, null, renderItemsMenu ? React.createElement(ItemsMenu, {
    ariaLabel: "Matchinformation och statistik",
    branding: "statistics-nav",
    className: itemsMenuClassNames.join(' '),
    hiddenScrollbar: menuOptions.hiddenScrollbar,
    useScrollFaders: menuOptions.useScrollFaders,
    useScrollHelpers: menuOptions.useScrollHelpers
  }, menuItems.map(_ref2 => {
    let label = _ref2.label,
      testIdSuffix = _ref2.testIdSuffix,
      to = _ref2.to,
      componentKey = _ref2.componentKey;
    const dataTestId = testIdSuffix === mutualsElementClassName ? mutualsElementClassName : "statistic-menu-".concat(testIdSuffix);
    return React.createElement(LinkItemRoute, _extends({}, tabComponent ? {
      Component: tabComponent
    } : {}, {
      "data-test-id": dataTestId,
      key: componentKey,
      label: label,
      onClick: setActiveTab && (() => setActiveTab(label)),
      selectedOnPaths: getSelectedOnPaths(activeTabBasePaths, componentKey),
      to: _objectSpread(_objectSpread({}, to), {}, {
        search: appendTabSearchParams ? String(appendTabSearchParams) : ''
      })
    }));
  }), React.createElement("span", {
    className: "tipsen-side-nav-end-spacer"
  })) : React.createElement("div", {
    className: "items-menu-placeholder"
  }), React.createElement("div", tabAreaClassName ? {
    className: tabAreaClassName
  } : {}, React.createElement(Switch, null, menuItems && menuItems.map(_ref3 => {
    let componentKey = _ref3.componentKey,
      getPath = _ref3.getPath,
      to = _ref3.to;
    return React.createElement(Route, {
      exact: to.pathname === '',
      key: componentKey,
      path: getPath(basePath),
      render: () => React.createElement(SportinfoContentView, {
        branding: branding,
        className: className,
        content: content[componentKey],
        drawNumber: drawNumber,
        eventNumber: eventNumber,
        eventTypeId: eventTypeId,
        externalId: externalId,
        FallbackComp: FallbackComp,
        lazyComponentsMap: lazyComponentsMap,
        matchId: matchId,
        productId: productId,
        setCoupon: setCoupon,
        sportType: sportType,
        theme: theme
      })
    });
  }))));
};
setGlobal('svs.components.sportinfo.sportinfo.Sportinfo', Sportinfo);

 })(window);